<template>
  <IadWrapper
    class="bg-secondary-40 rounded-t-3xl lg:rounded-t-none"
    inner-classes="flex flex-col items-center gap-2xl py-2xl"
  >
    <ol class="grid lg:grid-cols-3 gap-xl px-l">
      <li class="flex flex-col gap-l item-center text-center">
        <span
          class="flex justify-center items-center self-center bg-secondary-70 rounded-full size-20 lg:size-28 font-semibold text-[2.5rem] lg:text-[3.75rem]"
        >
          <Icon name="iad-icon:person" />
        </span>

        <div class="text-white">
          <IadTitle
            class="pb-s"
            tag="p"
            variant="large"
            :text="$n(15_000)"
          />
          <p
            class="text-xl"
            v-text="$t(`agent.valuation.reinsurance.first_step.description`)"
          />
        </div>
      </li>
      <li class="flex flex-col gap-l item-center text-center">
        <span
          class="flex justify-center items-center self-center bg-secondary-70 rounded-full size-20 lg:size-28 font-semibold text-[2.5rem] lg:text-[3.75rem]"
        >
          <Icon name="iad-icon:real-estate-agent" />
        </span>
        <div class="text-white">
          <IadTitle
            class="pb-s"
            tag="p"
            variant="large"
            :text="$n(110_000)"
          />
          <p
            class="text-xl"
            v-text="$t(`agent.valuation.reinsurance.second_step.description`)"
          />
        </div>
      </li>
      <li class="flex flex-col gap-l item-center text-center">
        <span
          class="flex justify-center items-center self-center bg-secondary-70 rounded-full size-20 lg:size-28 font-semibold text-[2.5rem] lg:text-[3.75rem]"
        >
          <Icon name="iad-icon:globe" />
        </span>
        <div class="text-white">
          <IadTitle
            class="pb-s"
            tag="p"
            variant="large"
            :text="$t(`agent.valuation.reinsurance.third_step.title`)"
          />
          <p
            class="text-xl"
            v-text="$t(`agent.valuation.reinsurance.third_step.description`)"
          />
        </div>
      </li>
    </ol>
  </IadWrapper>
</template>
